// Palette centrale du site — voir l'audit couleurs pour le détail des remplacements.
const COLORS = {
  primary: '#435666', // Ardoise — marque, navigation, structure
  accent: '#C6862E', // Or — appels à l'action positifs, statut "en attente"
  success: '#2E9E6D', // Succès — payé, validé
  danger: '#C1493F', // Danger — uniquement destructeur (supprimer, erreur)
  fond: '#F5F5F2', // Fond neutre clair — sections, tableaux
  encre: '#262B30', // Texte courant sur fond clair
};

export default COLORS;
